"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var providers_1 = require("ethers/providers");
var baseWallet_1 = __importDefault(require("./baseWallet"));
var utils_1 = require("ethers/utils");
var ethUtil = __importStar(require("ethereumjs-util"));
var _1 = require(".");
var HydroWallet = (function (_super) {
    __extends(HydroWallet, _super);
    function HydroWallet(address, wallet) {
        var _this = _super.call(this) || this;
        _this._address = null;
        _this._wallet = null;
        _this._address = address.toLowerCase();
        if (wallet) {
            _this._wallet = wallet.connect(_this.getProvider());
        }
        return _this;
    }
    HydroWallet.createRandom = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, ethers_1.Wallet.createRandom()];
                    case 1:
                        wallet = _a.sent();
                        return [2, new HydroWallet(wallet.address, wallet)];
                }
            });
        });
    };
    HydroWallet.import = function (privateKey, password) {
        return __awaiter(this, void 0, void 0, function () {
            var wallet, hydroWallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, new ethers_1.Wallet(privateKey)];
                    case 1:
                        wallet = _a.sent();
                        hydroWallet = new HydroWallet(wallet.address, wallet);
                        return [4, hydroWallet.save(password)];
                    case 2:
                        _a.sent();
                        return [2, hydroWallet];
                }
            });
        });
    };
    HydroWallet.fromMnemonic = function (mnemonic, password) {
        return __awaiter(this, void 0, void 0, function () {
            var wallet, hydroWallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, ethers_1.Wallet.fromMnemonic(mnemonic)];
                    case 1:
                        wallet = _a.sent();
                        hydroWallet = new HydroWallet(wallet.address, wallet);
                        return [4, hydroWallet.save(password)];
                    case 2:
                        _a.sent();
                        return [2, hydroWallet];
                }
            });
        });
    };
    HydroWallet.prototype.save = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var data, wallets, index;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._wallet || !this._address) {
                            return [2, false];
                        }
                        return [4, this._wallet.encrypt(password)];
                    case 1:
                        data = _a.sent();
                        wallets = HydroWallet.getWalletData();
                        index = wallets.findIndex(function (json) { return HydroWallet.parseWalletAddress(json) === _this._address; });
                        if (index !== -1) {
                            wallets.splice(index, 1, data);
                        }
                        else {
                            wallets.push(data);
                        }
                        HydroWallet.setWalletData(wallets);
                        return [2, true];
                }
            });
        });
    };
    HydroWallet.prototype.delete = function () {
        var _this = this;
        this._wallet = null;
        HydroWallet._cache.delete(this._address);
        var wallets = HydroWallet.getWalletData().filter(function (json) { return HydroWallet.parseWalletAddress(json) !== _this._address; });
        HydroWallet.setWalletData(wallets);
        return true;
    };
    HydroWallet.prototype.type = function () {
        return HydroWallet.TYPE;
    };
    HydroWallet.prototype.id = function () {
        return HydroWallet.TYPE + ":" + this._address;
    };
    HydroWallet.list = function () {
        var _this = this;
        return this.getWalletData().map(function (json) {
            return _this.getWallet(_this.parseWalletAddress(json));
        });
    };
    HydroWallet.setWalletData = function (wallets) {
        localStorage.setItem(this.WALLETS_KEY, JSON.stringify(wallets));
    };
    HydroWallet.getWalletData = function () {
        return JSON.parse(localStorage.getItem(this.WALLETS_KEY) || "[]");
    };
    HydroWallet.parseWalletAddress = function (json) {
        return ethers_1.utils.getAddress(JSON.parse(json).address).toLowerCase();
    };
    HydroWallet.getWallet = function (address, _wallet) {
        var wallet = this._cache.get(address);
        if (!wallet || wallet._address !== address) {
            wallet = new HydroWallet(address, _wallet);
            this._cache.set(address, wallet);
        }
        return wallet;
    };
    HydroWallet.prototype.signMessage = function (message) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this._wallet) {
                reject(baseWallet_1.default.NeedUnlockWalletError);
            }
            else {
                resolve(_this._wallet.signMessage(message));
            }
        });
    };
    HydroWallet.prototype.signPersonalMessage = function (message) {
        return this.signMessage(ethUtil.toBuffer(message));
    };
    HydroWallet.prototype.sendTransaction = function (txParams) {
        return __awaiter(this, void 0, void 0, function () {
            var address, _a, tx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        address = this._address;
                        if (!(address !== null)) return [3, 2];
                        _a = txParams;
                        return [4, _1.getTransactionCount(address, "pending")];
                    case 1:
                        _a.nonce = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (txParams.value) {
                            txParams.value = new utils_1.BigNumber(txParams.value);
                        }
                        if (!!this._wallet) return [3, 3];
                        return [2, Promise.reject(baseWallet_1.default.NeedUnlockWalletError)];
                    case 3: return [4, this._wallet.sendTransaction(txParams)];
                    case 4:
                        tx = _b.sent();
                        return [2, tx.hash];
                }
            });
        });
    };
    HydroWallet.prototype.sendCustomRequest = function (method, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._provider) return [3, 1];
                        return [2, Promise.resolve({ error: baseWallet_1.default.NeedUnlockWalletError })];
                    case 1: return [4, this._provider.send(method, params)];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    HydroWallet.prototype.getAddresses = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this._address) {
                resolve([_this._address]);
            }
            else {
                resolve([]);
            }
        });
    };
    HydroWallet.prototype.loadNetworkId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var network;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._wallet || !this._wallet.provider) {
                            return [2];
                        }
                        return [4, this._wallet.provider.getNetwork()];
                    case 1:
                        network = _a.sent();
                        return [2, network.chainId];
                }
            });
        });
    };
    HydroWallet.prototype.lock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._wallet = null;
                return [2];
            });
        });
    };
    HydroWallet.prototype.unlock = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var json, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        json = HydroWallet.getWalletData().find(function (json) { return HydroWallet.parseWalletAddress(json) === _this._address; });
                        _a = this;
                        return [4, ethers_1.Wallet.fromEncryptedJson(json, password)];
                    case 1:
                        _a._wallet = _b.sent();
                        this._wallet = this._wallet.connect(this.getProvider());
                        this.resetTimeout();
                        return [2];
                }
            });
        });
    };
    HydroWallet.prototype.isLocked = function () {
        return !this._wallet;
    };
    HydroWallet.prototype.isSupported = function () {
        return true;
    };
    HydroWallet.prototype.getProvider = function () {
        if (this._provider) {
            return this._provider;
        }
        this._provider = new providers_1.JsonRpcProvider(_1.globalNodeUrl);
        return this._provider;
    };
    HydroWallet.prototype.getMnemonic = function () {
        if (!this._wallet) {
            throw baseWallet_1.default.NeedUnlockWalletError;
        }
        this.resetTimeout();
        return this._wallet.mnemonic;
    };
    HydroWallet.prototype.getPrivateKey = function () {
        if (!this._wallet) {
            throw baseWallet_1.default.NeedUnlockWalletError;
        }
        this.resetTimeout();
        return this._wallet.privateKey;
    };
    HydroWallet.prototype.resetTimeout = function () {
        var _this = this;
        if (this._timer) {
            window.clearTimeout(this._timer);
        }
        this._timer = window.setTimeout(function () { return _this.lock(); }, HydroWallet.TIMEOUT);
    };
    HydroWallet.prototype.name = function () {
        return "Hydro Wallet";
    };
    HydroWallet.TIMEOUT = 15 * 60 * 1000;
    HydroWallet.WALLETS_KEY = "Hydro-Wallets";
    HydroWallet._cache = new Map();
    HydroWallet.TYPE = "Hydro_Wallet";
    HydroWallet.LABEL = "Browser Wallet";
    return HydroWallet;
}(baseWallet_1.default));
exports.default = HydroWallet;
